<script lang="ts" setup>
const props = defineProps<{
  name: string
}>()

const { galleryOptions } = useUiMediaGallery(props.name)
const { close: closeFullscreen } = useUiDialog('media-gallery')
</script>

<template>
  <LazyUiDialog
    class="media-gallery-fullscreen"
    :name="props.name"
    dialog-type="fullscreen"
  >
    <div class="media-gallery-fullscreen__container">
      <button
        class="media-gallery-fullscreen__close"
        @click="closeFullscreen"
      >
        <Icon
          name="icon:close"
          class="icon icon--search"
          aria-hidden="true"
        />
      </button>
      <UiMediaGalleryThumbs
        v-if="galleryOptions.fullscreenOptions.thumbs"
        :name="props.name"
        class="media-gallery-fullscreen__thumbs"
        :thumbs-direction="galleryOptions.fullscreenOptions.thumbsDirection"
        :thumbs-trigger="galleryOptions.fullscreenOptions.thumbsTrigger"
      >
        <template #thumbs-prev-icon>
          <slot name="thumbs-prev-icon" />
        </template>

        <template #thumbs-next-icon>
          <slot name="thumbs-next-icon" />
        </template>
      </UiMediaGalleryThumbs>

      <UiMediaGalleryFullscreenMain
        :name="props.name"
        class="media-gallery-fullscreen__main"
      />

      <UiMediaGalleryXofY
        v-if="galleryOptions.fullscreenOptions.XofY"
        :name="props.name"
        class="media-gallery-fullscreen__x-of-y"
      >
        <template #divider>
          van
        </template>
      </UiMediaGalleryXofY>

      <UiMediaGalleryNavigation
        v-if="galleryOptions.fullscreenOptions.navigation"
        :name="props.name"
        class="media-gallery-fullscreen__navigation"
      >
        <template #gallery-prev-icon>
          <slot name="gallery-prev-icon" />
        </template>

        <template #gallery-next-icon>
          <slot name="gallery-next-icon" />
        </template>
      </UiMediaGalleryNavigation>

      <LazyUiMediaGalleryDots
        v-if="galleryOptions.fullscreenOptions.dots"
        :name="props.name"
        class="media-gallery__dots"
      />
    </div>
  </LazyUiDialog>
</template>

<style>
@import url("~layers/app/components/Ui/MediaGallery/Fullscreen.css");
</style>
